export type ForestPath = number[];

export type Tree<A> = Leaf<A> | Fork<A>;
export type Forest<A> = [...Leaf<A>[], Fork<A>] | Leaf<A>[];

export type Leaf<A> = {
  type: 'leaf';
  value: A;
  path: ForestPath;
  forks: ForestPath[];
};
export type Fork<A> = { type: 'fork'; children: Forest<A>[] };

export type FlatTree<A> = {
  value: A;
  path: ForestPath;
  forks: ForestPath[];
};

export const flattenAtPath = <A>(
  forest: Forest<A>,
  path: ForestPath
): FlatTree<A>[] => {
  const result: FlatTree<A>[] = [];
  const pathQueue = [...path];

  let activeForest = forest.slice(0);
  while (activeForest.length > 0) {
    const tree = activeForest.shift();
    if (!tree) break;

    if (tree.type === 'leaf') {
      result.push({
        value: tree.value,
        path: tree.path,
        forks: tree.forks,
      });
    }

    if (tree.type === 'fork') {
      const index = pathQueue.shift() ?? -1;
      activeForest = (
        tree.children.at(index) ??
        tree.children.at(-1) ??
        []
      ).slice(0);
    }
  }

  return result;
};
